export enum FormDisplayMode {
    Standard = 'Standard',
    Summary = 'Summary',
    Filters = 'Filters',
    Static = 'Static',
}
